import React, { useEffect, useState } from "react";
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, TextField, Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import pluginServices from "app/services/plugin-services";
import { pluginErrorMessage } from "./pluginHelpers";

const whatsappContractLink = (plugin) => {
    const message = encodeURIComponent(`Hola, quiero contratar el plugin ${plugin?.name || ""}.`);
    return `https://wa.me/56936662426?text=${message}`;
};

// Pedir un plugin que la empresa no tiene contratado: por WhatsApp o con un mensaje a soporte.
const PluginRequestDialog = ({ plugin, onClose, onSent }) => {
    const [message, setMessage] = useState("");
    const [sending, setSending] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        setMessage("");
        setError(null);
    }, [plugin]);

    if (!plugin) return null;

    const send = async () => {
        setSending(true);
        setError(null);
        try {
            await pluginServices.requestPlugin({ plugin_id: plugin.id, message });
            onSent(plugin);
        } catch (requestError) {
            setError(pluginErrorMessage(requestError, "No se pudo enviar la solicitud."));
        } finally {
            setSending(false);
        }
    };

    return (
        <Dialog open onClose={sending ? undefined : onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Solicitar «{plugin.name}»</DialogTitle>
            <DialogContent dividers>
                <Stack spacing={2}>
                    <Typography variant="body2" color="text.secondary">
                        Este plugin no está contratado para tu empresa. Escríbenos por WhatsApp o déjanos un mensaje y te contactamos.
                    </Typography>
                    <Button variant="outlined" color="success" startIcon={<WhatsAppIcon />} component="a" href={whatsappContractLink(plugin)}
                            target="_blank" rel="noopener noreferrer" sx={{ alignSelf: "flex-start" }}>
                        Hablar por WhatsApp
                    </Button>
                    <TextField
                        fullWidth multiline minRows={3} label="Mensaje para Xpit (opcional)"
                        placeholder={`Quiero contratar el plugin ${plugin.name}`}
                        value={message} onChange={(event) => setMessage(event.target.value)}
                    />
                    {!!error && <Alert severity="error">{error}</Alert>}
                </Stack>
            </DialogContent>
            <DialogActions sx={{ px: 3, py: 1.5 }}>
                <Button onClick={onClose} disabled={sending}>Cancelar</Button>
                <LoadingButton variant="contained" loading={sending} onClick={send}>Enviar solicitud</LoadingButton>
            </DialogActions>
        </Dialog>
    );
};

export default PluginRequestDialog;
